import theme from './ProjectLicenses.module.scss';
import React from 'react';
import { ProjectLicensesUnits } from './ProjectLicensesUnits';
import { BygrProject } from '@/types';
import ProjectLicensesRuben from './ProjectLicensesRuben';

interface ProjectLicensesProps {
    project: BygrProject;
}

const ProjectLicenses: React.FC<ProjectLicensesProps> = (props) => {
    // Implement the component logic here

    return (
        <div className={theme.licenses}>
            <ProjectLicensesUnits project={props.project}/>
            <ProjectLicensesRuben project={props.project}/>
        </div>        
    );
};

export default ProjectLicenses;